import React, {useMemo} from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../hooks/useIsMobileViewport';
import appRouterService from '../../../services/app/appRouterService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {IconCopy, IconDiagnostic, IconEdit, IconTrashCan} from '../../Icons';
import MobileOptionsMenu from '../MobileOptionsMenu';
import OptionsMenu from '../OptionsMenu';

const BuildingOptionsMenu = ({record, dataSource, handlers, organizationId}) => {
    const isMobile = useIsMobileViewport();
    const localizedStrings = getLocalizedStrings();

    const menuItems = useMemo(
        () =>
            [
                {
                    key: 'diagnostics',
                    icon: <IconDiagnostic />,
                    label: localizedStrings[localizationKeys.COMPANY_DIAGNOSIS_BUTTON],
                    onClick: () =>
                        appRouterService.forwardToDiagnosticPage(
                            String(record?.id ?? ''),
                            String(organizationId ?? '')
                        ),
                },
                {
                    key: 'edit',
                    icon: <IconEdit />,
                    label: localizedStrings[localizationKeys.BUILDING_MENU_OPTION_EDIT],
                    onClick: () => handlers.onEditClick(record),
                },
                {
                    key: 'copy',
                    isVisible: !isMobile || Boolean(handlers?.onCopyClick),
                    icon: <IconCopy />,
                    label: localizedStrings[localizationKeys.BUILDING_MENU_OPTION_COPY],
                    onClick: () => handlers?.onCopyClick(record),
                },
                {
                    key: 'delete',
                    danger: true,
                    icon: <IconTrashCan />,
                    label: localizedStrings[localizationKeys.BUILDING_MENU_OPTION_DELETE],
                    onClick: () => handlers.handleDelete(record),
                    isActionConfirmRequired: true,
                },
            ].filter((item) => item.isVisible !== false),
        [localizedStrings, record, organizationId, handlers, isMobile]
    );

    if (isMobile) {
        return (
            <MobileOptionsMenu
                menuItems={menuItems}
                label={localizedStrings.formatString(
                    localizedStrings[localizationKeys.ORG_DETAILS_BUILDING_ACTIONS],
                    record?.address || record?.name || ''
                )}
            />
        );
    }

    return <OptionsMenu className={'left'} menuItems={menuItems} record={record} dataSource={dataSource} />;
};

export default BuildingOptionsMenu;
